import { z } from 'zod'

const queryLeafNodeSchema = z.object({
  type: z.literal('QUERY_LEAF_NODE'),
  value: z.string(),
})

export interface QueryNode {
  type: 'QUERY_LEAF_NODE' | 'AND_NODE' | 'OR_NODE'
  value?: string
  child?: QueryNode
  children?: QueryNode[]
}

// Need to use z.lazy for recursive types.
const queryNodeSchema: z.ZodType<QueryNode> = z.lazy(() =>
  z.discriminatedUnion('type', [queryLeafNodeSchema, andOrNodeSchema])
)

const andOrNodeSchema = z.object({
  type: z.enum(['AND_NODE', 'OR_NODE']),
  children: z.array(queryNodeSchema).min(2),
})

export const createSearchQueryIntersectionInputSchema = z.object({
  query: queryNodeSchema,
})

export const searchQueryIntersectionDataSchema = z
  .object({
    id: z.string(),
    search: z.string(),
    query: queryNodeSchema,
    text: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .transform((data) => {
    const { created_at, updated_at, ...rest } = data
    return {
      ...rest,
      createdAt: created_at,
      updatedAt: updated_at,
    }
  })

export type SearchQueryIntersectionData = z.infer<
  typeof searchQueryIntersectionDataSchema
>

export const searchQueryIntersectionOutputSchema = z.object({
  data: searchQueryIntersectionDataSchema,
  message: z.string(),
})

export type SearchQueryIntersectionAPI = z.infer<
  typeof searchQueryIntersectionOutputSchema
>
